<template>
    <AppNavigation>
        <mdb-container fluid>
            <h1 class="h1-responsive">Rider Withdrawal</h1>
            <hr>
            <mdb-tabs
            :active="this.index"
            default
            v-on:activeTab="onChangeActiveTab"
            tag="div"
            :links="[
            { text: 'Withdrawal List', slot: 'partner_list' },
            { text: 'Withdrawal Batch', slot: 'partner_batch' }]"
            />
            <PartnerWithdrawalList :navigate="listNavigate" ref="listref" class="my-2" v-show="index==0" />
            <PartnerWithdrawalBatch :navigate="batchNavigate" ref="batchref" class="my-2" v-show="index==1" />
        </mdb-container>
    </AppNavigation>
</template>

<script>
// @ is an alias to /src
import {mdbContainer, mdbTabs} from 'mdbvue';
import AppNavigation from '../components/AppNavigation';
import PartnerWithdrawalBatch from './PartnerWithdrawalBatch';
import PartnerWithdrawalList from './PartnerWithdrawalList';
// import {ajax} from '../js/ajax';
// import {momentFormat16} from '../js/helper';

export default {
    name: 'partner_wallet_withdrawal',
    components: {
        mdbContainer, AppNavigation, mdbTabs, PartnerWithdrawalList, PartnerWithdrawalBatch
    },
    data: ()=>({
        loading: false,
        index: 0
    }),
    methods: {
        onChangeActiveTab(index){
            this.index=index;
        },
        listNavigate(ref){
            this.index=1;
            this.$refs.batchref.accept(ref);
        },  
        batchNavigate(ref){
            this.index=0;
            this.$refs.listref.accept(ref);
        }
    },
    mounted: function(){
    }
}
</script>
